import React from "react";
import { Link, useLocation } from "react-router-dom";
import './NotFoundPage.css';
import {IoMdHome} from "react-icons/io";

const NoPermission = () => {
    const location = useLocation();

    const basePath = location.pathname.includes("/dashboard") ? "/dashboard/home" : "/";

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <p className="not-found-description">
                   თქვენ არ გაქვს წვდომა მოცემული სახის განაცხადებზე.
                </p>
                <p className="suggestion">
                   წვდომის მისაღებად მიმართეთ ადმინისტრაციას!
                </p>
                <Link to={basePath} className="home-button">
                    <IoMdHome /> მთავარი გვერდი
                </Link>
            </div>
        </div>
    );
};

export default NoPermission;
